import z from 'zod';
import { SanityDocumentSchema } from '../sanity';
import { ComponentType } from '$lib/sanity/types';
import { ImageObjectSchema } from './Image';
import { VideoSchema } from './Video';
import { PageCollectionThemeSchema } from '../shared';

export const PageFullWidthMediaSchema = SanityDocumentSchema.extend({
  _type: z.literal(ComponentType.PageFullWidthMedia),
  theme: PageCollectionThemeSchema.nullable().optional(),
  image: ImageObjectSchema.nullable().optional(),
  altText: z.string().nullable().optional(),
  video: VideoSchema.nullable().optional()
});

export type PageFullWidthMedia = z.infer<typeof PageFullWidthMediaSchema>;
